import { getDoc } from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage";
import { DocumentData, DocumentReference, store } from "shared/api/firebase";
import { ContentBlocksModuleLayout, ModuleData, ModuleType } from "../types";
import { THREE_CARD_BLOCK_KEY } from "../utils";

type Params = {
  moduleRef: DocumentReference<DocumentData>;
};

export const deleteContentBlocksModuleImages = async ({
  moduleRef,
}: Params) => {
  const module = (await getDoc(moduleRef)).data() as ModuleData;

  if (
    module.type !== ModuleType.ContentBlocks ||
    module.layout !== ContentBlocksModuleLayout.ThreeCardBlock ||
    !module.contentBlocks ||
    !module.contentBlocks?.length
  ) {
    return null;
  }

  await Promise.all(
    module.contentBlocks.map(async (item, index) => {
      if (!item.backgroundImage) {
        return null;
      }
      // References for logo and background images
      const path = `moduleTemplates/${moduleRef.id}/${THREE_CARD_BLOCK_KEY}-${index}`;
      const imgStorageRef = ref(store, path);

      await deleteObject(imgStorageRef);
    }),
  );
};
